export default "c8ff230278818a37.svg"